// CleanPageBanner.jsx - Clean Centered Banner with optional background image
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/customer/components/PageBanner.css';

const PageBanner = ({ 
  title = "Page Title",
  subtitle = "Your page description goes here",
  buttonText,
  buttonLink = "/",
  breadcrumbs = [],
  backgroundImage = "https://i.pinimg.com/1200x/cc/d0/53/ccd053a5e6f07d5f0c1aec8a3cc57a46.jpg",     // 👈 image URL ya import
  overlayColor = "rgba(255,255,255,0.15)", // 👈 overlay ka color + opacity
}) => {
  const navigate = useNavigate();
  const hasImage = !!backgroundImage;

  return (
    <div 
      className={`clean-page-banner ${hasImage ? 'has-bg-image' : ''}`}
      style={hasImage ? { background: 'none' } : {}}
    >
      {/* Background Image */}
      {hasImage && (
        <img 
          src={backgroundImage} 
          alt="" 
          className="banner-bg-image" 
          aria-hidden="true"
        />
      )}

      {/* Overlay (sirf image mode mein) */}
      {hasImage && (
        <div 
          className="banner-overlay" 
          style={{ background: overlayColor }}
        />
      )}

      {/* Animated Background Shapes */}
      <div className="clean-banner-shapes">
        <div className="clean-shape shape-1"></div>
        <div className="clean-shape shape-2"></div>
        <div className="clean-shape shape-3"></div>
      </div>

      {/* Content Container */}
      <div className="clean-banner-container">
        <div className="clean-banner-content">

          {/* Breadcrumb */}
          {breadcrumbs.length > 0 && (
            <div className={`clean-breadcrumb ${hasImage ? 'breadcrumb-light' : ''}`}>
              <button onClick={() => navigate('/')}>Home</button>
              {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={index}>
                  <span className="breadcrumb-arrow">/</span>
                  {crumb.link ? (
                    <button onClick={() => navigate(crumb.link)}>
                      {crumb.label}
                    </button>
                  ) : (
                    <span className="breadcrumb-current">{crumb.label}</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          {/* Main Title */}
          <h1 className={`page-banner-title ${hasImage ? 'title-light' : ''}`}>
            {title}
          </h1>

          {/* Subtitle */}
          <p className={`clean-banner-subtitle ${hasImage ? 'subtitle-light' : ''}`}>
            {subtitle}
          </p>

          {/* Decorative Line */}
          {/* <div className="clean-decorative-line">
            <div className={`line-left ${hasImage ? 'line-white' : ''}`}></div>
            <div className={`line-dot ${hasImage ? 'dot-white' : ''}`}></div>
            <div className={`line-right ${hasImage ? 'line-white' : ''}`}></div>
          </div> */}
        </div>
      </div>

      
    </div>
  );
};

export default PageBanner;